import moment from "moment";
import { useTranslation } from "react-i18next";

interface FieldBlockProps {
  label: string;
  value: any;
  date?: boolean;
  price?: boolean;
}

const DATE_FORMAT = "MMMM Do, YYYY";

const PlanCardField = ({ label, value, date, price }: FieldBlockProps) => {
  const { t } = useTranslation();
  if (date) {
    value = value ? moment(value).format(DATE_FORMAT) : "-";
  } else if (price) {
    value = value ? "$" + value : "-";
  }
  return (
    <div className="grid grid-cols-2">
      <div className="font-medium text-black text-sm">{t(label)}</div>
      <div className="text-sm">{value || "-"}</div>
    </div>
  );
};

export default PlanCardField;
